import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import IWorkflowElement from "@/interfaces/workflow-element.interfaces";
import workflowService from "@/services/workflow.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetWorkflowElementByIdReturn = RequestsBaseReturn<IWorkflowElement | null>;

export type UseGetWorkflowElementByIdProps = ByIdRequestProps;

type UseSwrGetWorkflowElementByIdParams = [string, number];

const useGetWorkflowElementById = ({
  _id,
}: UseGetWorkflowElementByIdProps): UseGetWorkflowElementByIdReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<IWorkflowElement, Error, UseSwrGetWorkflowElementByIdParams | null>(
    _id ? [SWR_KEYS.getWorkflowElementById, _id] : null,
    ([, workflowElementId]) => workflowService.getWorkflowElementById(workflowElementId),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetWorkflowElementById;
